module.exports = __webpack_public_path__ + "img/logo-nova.3a52ac44.png";